import { render, staticRenderFns } from "./DialogVersion.vue?vue&type=template&id=4cef1690&scoped=true&lang=true"
import script from "./DialogVersion.vue?vue&type=script&lang=js"
export * from "./DialogVersion.vue?vue&type=script&lang=js"
import style0 from "./DialogVersion.vue?vue&type=style&index=0&id=4cef1690&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cef1690",
  null
  
)

export default component.exports